import { combineReducers } from 'redux';
import response from './response';

export default combineReducers({
  response,
});
